<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel)"
    :name="MODAL_NAMES.BOUYGUES"
    :title="i18n(translations.title)"
    @open="fetchOffersWithPerks"
  >
    <template #body>
      <div v-if="isLoading" class="flex justify-center py-32">
        <RevSpinner size="large" />
      </div>

      <BouyguesOffers v-else-if="offersWithPerks" :offers="offersWithPerks" />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type {
  MobilePlanOffer,
  MobilePlanOfferWithPerks,
} from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevSpinner } from '@ds/components/Spinner'

import BouyguesOffers from '~/scopes/partnerships/components/BouyguesOffers/BouyguesOffers.vue'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './BouyguesOffersDrawer.translations'

const i18n = useI18n()

const props = defineProps<{
  offers:
    | MobilePlanOffer[]
    | GetProductResponse['includedServiceOffers']['mobilePlans']
}>()

const $httpFetch = useHttpFetch()

const offersWithPerks = ref<MobilePlanOfferWithPerks[] | null>(null)
const isLoading = ref(false)

async function fetchOffersWithPerks() {
  isLoading.value = true

  try {
    offersWithPerks.value = await $httpFetch('/mobile-plan/api/v1/offers', {
      method: 'GET',
      query: {
        partner: props.offers[0].partner.name,
        marketCode: props.offers[0].marketCode,
        offerIds: props.offers.map((offer) => offer.id),
      },
    })
  } finally {
    isLoading.value = false
  }
}
</script>
